import { all } from 'redux-saga/effects';
import productSyncingSaga from './productSyncing';
import facebookSaga from './facebook';
import outletModalSaga from './outletModal';
import shopSaga from './shop';
import googleSaga from './google';
import productExportSaga from './productExport';

export default function* onlineStoreSaga() {
  yield all([
    productSyncingSaga(),
    facebookSaga(),
    outletModalSaga(),
    shopSaga(),
    googleSaga(),
    productExportSaga(),
  ]);
}
